<template>
	<div class="session-user-display">
		<template v-if="sessionUserDisplay.data">
			<div
				v-if="sessionUserDisplay.data.length"
				class="session-user-display__cards"
			>
				<div
					class="user-card"
                    :class="{
                        'large' :  sessionUserDisplay.data.length > 0 && sessionUserDisplay.data.length < 4,
                        'medium' :sessionUserDisplay.data.length > 3 && sessionUserDisplay.data.length < 11,
                    }"
					v-for="(user, index) in sessionUserDisplay.data"
					:key="index"
				>
					<SessionUserCard
						:avatar="user.image"
						:name="user.name"
						:emotion="user.emotion_value"
						:emotion-img="user.filepath"
						:stress="user.stress_level"
						:stress-img="user.heart_path"
						:bpm="user.progress_bpm"
						:calories="user.calories"
						:status="!!user.status"
						:progress="(user.progress_value / 180000) * 100"
                        :isFitness="user.is_fitness"
					/>
				</div>
			</div>

			<div class="session-user-display__empty" v-else>
				<h4>
					{{ $t('no_data_found') }}
				</h4>
				<p>{{ $t('collect_emotion_data') }}</p>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import sessionModule from '@/store/session/app.js'
import SessionUserCard from '@/components/session/SessionUserCard'

export default {
	data () {
		return {
			pollingTimeout: null
		}
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['session/']) {
			this.$store.registerModule('session', sessionModule)
		}
	},

	async mounted () {
		await this.fetchPolling()
		this.$emit('mounted')
	},

	computed: {
		...mapState('session', [
			'loading',
			'session',
			'sessionUserDisplay'
		])
	},

	components: {
		SessionUserCard
	},

	methods: {
		async fetchPolling () {
			if (this.pollingTimeout) clearTimeout(this.pollingTimeout)

			await this.$store.dispatch('session/getSessionUserShareLink', this.$route.query)

			this.pollingTimeout = setTimeout(async () => {
				this.fetchPolling()
			}, 10000)
		}
	}
}
</script>

<style lang="scss" scoped>
.session-user-display {
	background-color: #FAFBFD;
	overflow: auto;
	height: 100%;

	&__cards {
		padding: 10px;
		display: inline-flex;
		align-items: flex-start;
		flex-flow: row wrap;

		.user-card {
			width: 190px;
			margin-bottom: 20px;
			padding: 10px;

            /deep/ .stress-wrap {
                .stress-level {
                    width: 38px;
                    text-align: center;
                }

                .bpm {
                    width: 47px;
                }
            }

            &.large {
                width: 394px;

                /deep/ .session-user-card {
                    font-size: 22px;
                    padding: 30px;
                }

                /deep/ .session-user-card__emotion {
                    font-size: 44px;
                }

                /deep/ .session-user-card__footer {
                    font-size: 24px;
                    &:first-child {
                        margin-top: 30px;
                    }
                }

                /deep/ .stress-wrap {
                    .stress-level {
                        width: 82px;
                        text-align: center;
                    }

                    .bpm {
                        width: 102px;
                    }
                }
            }

            &.medium {
                width: 245px;

                /deep/ .session-user-card {
                    font-size: 21px;
                    padding: 30px 10px;
                }

                /deep/ .session-user-card__emotion {
                    font-size: 36px;
                    text-transform: capitalize;
                }

                /deep/ .session-user-card__footer {
                    font-size: 16px;
                    &:first-child {
                        margin-top: 30px;
                    }
                }

                /deep/ .stress-wrap {
                    .stress-level {
                        width: 57px;
                        text-align: center;
                    }

                    .bpm {
                        width: 70px;
                    }
                }
            }
		}
	}

	// &__footer {
	// 	display: flex;
	// 	justify-content: flex-end;
	// 	padding: 20px;
	// }

	&__empty {
		height: 500px;
		margin: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-color: #F0F0F7;
		color: #BFCCE2;
		font-size: 1em;
		line-height: 1.5em;
	}
}
</style>
